export const eBoksGradient = 'linear-gradient(to right, rgba(188, 31, 48, 1) 0%, rgba(135, 32, 88, 1) 100%)';
export const defaultProjectColor = '#a8242f';
